export class HoldOffMenuRotation {
  constructor(menuId: string) {
    this.menuIdRequestingHold = menuId;
  }

  public menuIdRequestingHold: string;
}
